import { useUser } from '@/store/user';

export const RESOURCED_BRAND_ID = 2242;

/**
 * The Resourced Internal admin pages: for holders of the global Admin role, shown while on the
 * Resourced brand. The API checks the role itself; the brand only decides where the pages live.
 */
export function canSeeResourcedInternal(): boolean {
  return Boolean(useUser().isAdmin) && useUser().brandId === RESOURCED_BRAND_ID;
}
